import React, { useState, useEffect, useCallback } from "react";
import { _registerDialogHandlers } from "../utils/dialogs";

const TITLES = {
  warning: "⚠️ Avertissement",
  error: "⚠️ Erreur",
  info: "ℹ️ Information",
  success: "✓ Succès",
};
const COLORS = {
  warning: "#dc2626",
  error: "#dc2626",
  info: "#2563eb",
  success: "#059669",
};

// Monté une seule fois à la racine de l'app (voir index.js) — fournit les
// boites de dialogue affichées par qlAlert()/qlConfirm() (utils/dialogs.js),
// à la place de window.alert()/window.confirm() natifs du navigateur.
export default function DialogProvider() {
  const [alertState, setAlertState] = useState(null); // { message, type }
  const [confirmState, setConfirmState] = useState(null); // { message, onConfirm, opts }

  useEffect(() => {
    _registerDialogHandlers(
      (message, type) => setAlertState({ message, type }),
      (message, onConfirm, opts) => setConfirmState({ message, onConfirm, opts: opts || {} })
    );
  }, []);

  const closeAlert = useCallback(() => setAlertState(null), []);

  const closeConfirm = useCallback((confirmed) => {
    setConfirmState((prev) => {
      if (confirmed && prev && prev.onConfirm) prev.onConfirm();
      return null;
    });
  }, []);

  return (
    <>
      {alertState && (
        <div className="ql-dialog-overlay" onClick={closeAlert}>
          <div className="ql-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="ql-dialog-header">
              <div className="ql-dialog-title" style={{ color: COLORS[alertState.type] || COLORS.warning }}>
                {TITLES[alertState.type] || TITLES.warning}
              </div>
              <button className="ql-dialog-close" onClick={closeAlert} aria-label="Fermer">&times;</button>
            </div>
            <div className="ql-dialog-body">{alertState.message}</div>
            <div className="ql-dialog-footer">
              <button className="ql-btn ql-btn-primary" onClick={closeAlert}>OK</button>
            </div>
          </div>
        </div>
      )}

      {confirmState && (
        <div className="ql-dialog-overlay" onClick={() => closeConfirm(false)}>
          <div className="ql-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="ql-dialog-header">
              <div className="ql-dialog-title">{confirmState.opts.title || "Confirmation"}</div>
              <button className="ql-dialog-close" onClick={() => closeConfirm(false)} aria-label="Fermer">&times;</button>
            </div>
            <div className="ql-dialog-body">{confirmState.message}</div>
            <div className="ql-dialog-footer">
              <button className="ql-btn ql-btn-outline" onClick={() => closeConfirm(false)}>Annuler</button>
              <button
                className={`ql-btn ${confirmState.opts.danger ? "ql-btn-danger" : "ql-btn-primary"}`}
                onClick={() => closeConfirm(true)}
              >
                {confirmState.opts.okLabel || "Confirmer"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
